import { c as _c } from "react/compiler-runtime";
import { InfoBar } from "@components/common/info-bar/info-bar";
import { InfoBarValue } from "@components/common/info-bar/info-bar-value";
import { Stack } from "@mui-wrapper";
import { useMediaQueryList } from "@hooks/use-media-query";
import { useHasValidFeatureProjectLevel } from "@hooks/feature-control/use-has-user-valid-feature-project-level";
import { CreateSnapshot } from "@pages/project-details/project-snapshots/create-snapshot";
import { SnapshotsBeingCreatedIndicator } from "@pages/project-details/project-snapshots/snapshots-being-created-indicator";
import { selectedProjectIdSelector, selectedProjectSnapshotsSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";

/** Renders a KPI bar for project snapshots tab */
export function ProjectSnapshotsKpi() {
  const $ = _c(14);
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const snapshots = useAppSelector(selectedProjectSnapshotsSelector);
  const selectedProjectId = useAppSelector(selectedProjectIdSelector);
  const {
    canCreateSnapshot
  } = useHasValidFeatureProjectLevel();
  if (!canCreateSnapshot) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      alignItems: "center",
      gap: 2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== snapshots.length) {
    t1 = <InfoBarValue>{snapshots.length}</InfoBarValue>;
    $[1] = snapshots.length;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SnapshotsBeingCreatedIndicator />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = [{
      label: "Snapshots",
      content: <Stack direction="row" sx={t0}>{t1}{t2}</Stack>
    }];
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== selectedProjectId) {
    t4 = selectedProjectId && <CreateSnapshot projectId={selectedProjectId} />;
    $[6] = selectedProjectId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = !canCreateSnapshot || isScreenSmOrSmaller;
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = {
      content: t4,
      isHidden: t5
    };
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <InfoBar items={t3} action={t6} />;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}